import * as React from "react";
import { useMemo, useState } from "react";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Events } from "@graylog/server-api";
import SuggestionsList from "components/common/EntityFilters/FilterConfiguration/SuggestionsList";
import useQuery_ from "routing/useQuery";
const DEFAULT_SEARCH_PARAMS = {
  query: "",
  pageSize: 10,
  page: 1
};
const TIMERANGE_30D = { type: "relative", range: 30 * 24 * 60 * 60 };
const MAX_RENDERED_SUGGESTIONS = 100;
const fetchTagSuggestions = (streamId, prefix) => Events.filterOptions({
  fields: ["tags"],
  query: streamId ? `source_streams:${streamId}` : "",
  field_query: prefix != null ? prefix : "",
  timerange: TIMERANGE_30D
}).then((response) => {
  var _a;
  return ((_a = response == null ? void 0 : response.tags) != null ? _a : []).map((value) => ({ id: value, value }));
});
export const createTagsFilter = ({
  queryKeyPrefix,
  fetchSuggestions,
  streamScoped = false,
  serverSidePrefix = false
}) => {
  const Filter = ({ attribute, allActiveFilters, filter, filterValueRenderer, onSubmit }) => {
    var _a, _b;
    const [searchParams, setSearchParams] = useState(DEFAULT_SEARCH_PARAMS);
    const { stream_id: streamId } = useQuery_();
    const streamIdParam = streamScoped && typeof streamId === "string" ? streamId : void 0;
    const prefixParam = serverSidePrefix ? searchParams.query : void 0;
    const {
      data: allSuggestions,
      isInitialLoading,
      isError
    } = useQuery({
      queryKey: [...queryKeyPrefix, streamIdParam != null ? streamIdParam : "all", ...serverSidePrefix ? [prefixParam] : []],
      queryFn: () => fetchSuggestions(streamIdParam, prefixParam),
      placeholderData: serverSidePrefix ? keepPreviousData : void 0
    });
    const suggestions = useMemo(
      () => allSuggestions ? allSuggestions.filter((s) => s.value.toLowerCase().includes(searchParams.query.toLowerCase())).slice(0, MAX_RENDERED_SUGGESTIONS) : allSuggestions,
      [allSuggestions, searchParams.query]
    );
    const effectiveSuggestions = isError ? [] : suggestions;
    return /* @__PURE__ */ React.createElement(
      SuggestionsList,
      {
        allActiveFilters,
        attribute,
        multiSelect: !filter,
        filterValueRenderer,
        onSubmit,
        suggestions: effectiveSuggestions,
        isLoading: isInitialLoading,
        total: (_a = effectiveSuggestions == null ? void 0 : effectiveSuggestions.length) != null ? _a : 0,
        page: 1,
        pageSize: (_b = effectiveSuggestions == null ? void 0 : effectiveSuggestions.length) != null ? _b : 0,
        setSearchParams
      }
    );
  };
  return Filter;
};
const TagsFilter = createTagsFilter({
  queryKeyPrefix: ["events", "tag-suggestions", `t${TIMERANGE_30D.range}`],
  fetchSuggestions: fetchTagSuggestions,
  streamScoped: true,
  serverSidePrefix: true
});
export default TagsFilter;
